import React from 'react'
import ChronoLogo from '@/layouts/core/components/ChronoLogo'

export const ChronoPageHeader = (props) => {
  const { children } = props
  return (
    <>
      <ChronoLogo/>
      {children}
    </>
  )
}